
      const publicPath =
        !import.meta.env.DEV && JSON.parse(IS_IN_BROWSER || "false")
          ? "/webapp"
          : ".";
      var script = document.createElement("script");
      script.type = "module";
      script.src = `${publicPath}/opus-recorder/dist/recorder.min.js`;
      document.head.appendChild(script);
    